import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddExternallyLink = ({ showModal, handleClose }) => {

  const [selectedRole, setSelectedRole] = useState('');
  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const [inputValueded, setInputValueded] = useState('');
  const handleInputChangeded = (event) => {
    setInputValueded(event.target.value);
  };
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const inputStyling = {
    padding: '8px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '200px',
    height: "35px",
    marginLeft: "47px" // Adjusted margin for better alignment
  };
  const inputStyleded = {
    padding: '8px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '200px',
    height: "35px",
    marginLeft: "40px" // Adjusted margin for better alignment
  };
  const containerStyled = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '20px 0',
    flexDirection: 'row',
  };
  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: '31px',
    cursor: 'pointer',
    marginLeft: '10px',
  };

  return (
    <div>
     <Modal 
        show={showModal} 
        onHide={handleClose}
        dialogClassName="modal-90w" size="lg">
     <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
            <Modal.Title className='heading' style={{ color: 'white', fontSize: '18px' }}>Add Externally Linked Case</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div style={containerStyled}>
          <b style={{fontSize:"15px"}}>External Type *</b>
          <select value={selectedRole} onChange={handleRoleChange} style={dropdownStyling}>
            <option value="Select Type">Select Type</option>
            <option value="Dexis Is">Dexis Is</option>
            <option value="Medit">Medit</option>
            <option value="Primescan">Primescan</option>
            <option value="Trios">Trios</option>
            <option value="Planscan">Planscan</option>
            <option value="True Definition">True Definition</option>
            <option value="Dental wings">Dental wings</option>
            <option value="Romexis">Romexis</option>
            <option value="Itero">Itero</option>
          </select>
        </div>
     
            <b style={{ marginLeft: "5px" }}>Case ID * </b>
            <input
              type="text"
              value={inputValueded}
              onChange={handleInputChangeded}
              style={inputStyling}
            />

            <br />
            <br />
            <b style={{ marginLeft: "5px" }}>Case URL </b>
            <input
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              style={inputStyleded}
            />
            <br />
            <br />

          </Modal.Body>
          <div style={{ padding: '0 15px 15px', textAlign: 'right' }}> {/* Adjusted button container */}
            <Button
              variant="secondary"
              onClick={handleClose}
              style={{
                backgroundColor: '#004aad',
                borderColor: '#004aad',
                marginRight:"580px"
              }}
            >
              Save
            </Button>
            </div>
      </Modal>
      </div>
  );
};

export default AddExternallyLink;
